import clsx from "clsx";

import { FavoriteLead } from "features/leads/components";
import { useLead } from "features/leads/datahooks";

import ProfileImage from "common/components/ui/ProfileImage";
import Skeleton from "common/components/ui/Skeleton";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import type { ConversationParticipant } from "common/types";

import { getParticipantJobInfo } from "../../../utils";

export default function GroupParticipantItem({
  participant,
  onSelect,
}: {
  participant: ConversationParticipant;
  onSelect: () => void;
}) {
  const { permissions } = useSelectedWorkspaceContext();
  const { lead, isLoadingLead } = useLead({
    profileId: participant.id,
  });

  const {
    full_name: fullName,
    id,
    is_lead: isLead,
    favorite: isFavorite,
  } = participant;

  const canViewPreview = permissions.includes("leads_full");

  const content = (
    <div className="flex flex-row items-center gap-2 border-b border-black-200 p-2 last:border-b-0">
      <ProfileImage
        className="size-8 rounded-full"
        src={participant.picture_url}
      />

      <div className="flex flex-col">
        <div className="flex flex-row gap-x-1">
          <span className="text-xs-bold">{fullName}</span>

          <FavoriteLead leadId={id} isLead={isLead} isFavorite={isFavorite} />
        </div>

        {isLoadingLead ? (
          <Skeleton className="h-4 w-44" />
        ) : (
          <span className="line-clamp-1 text-button-xxs text-black-500">
            {getParticipantJobInfo(lead)}
          </span>
        )}
      </div>
    </div>
  );

  const containerClassName = "w-full px-2 text-start";

  if (canViewPreview) {
    return (
      <button
        type="button"
        className={clsx(containerClassName, "hover:bg-black-100")}
        onClick={onSelect}
      >
        {content}
      </button>
    );
  }
  return <div className={containerClassName}>{content}</div>;
}
